import { gql } from "@apollo/client";

export const SCHEDULING_LINKS_QUERY = gql`
  query SchedulingLinksQuery($createLinkNameIfNone: Boolean) {
    viewer {
      id
      user {
        id
        givenName
        familyName
        linkNameErrorable(createLinkNameIfNone: $createLinkNameIfNone) {
          __typename
          ... on LinkName {
            linkName
          }
        }
        externalImageUrl
        orgs {
          edges {
            node {
              id
              name
              experiments
              workingGroups {
                edges {
                  node {
                    id
                  }
                }
              }
            }
          }
        }
        schedulingLinks(createLinkNameIfNone: $createLinkNameIfNone) {
          linkUrl
          linkName
          meetingSettings {
            id
            slug
            name
            isActive
            timingSettings {
              durationMinutes
            }
            availabilityType
          }
        }
      }
    }
  }
`;

export const UPDATE_USER_SHORTNAME_MUTATION = gql`
  mutation UpdateUserShortname($shortname: String!) {
    updateUserShortname(input: { shortname: $shortname }) {
      userErrorable {
        __typename
        ... on User {
          id
          linkNameErrorable {
            ... on LinkName {
              linkName
            }
          }
          schedulingLinks {
            linkUrl
            linkName
            meetingSettings {
              id
              slug
              name
              isActive
              timingSettings {
                durationMinutes
              }
              availabilityType
            }
          }
        }
        ... on GraphEntityError {
          message
          body
        }
      }
    }
  }
`;

export const VALIDATE_SHORTNAME_QUERY = gql`
  query CheckShortname($shortname: String!) {
    viewer {
      validateUserShortname(shortname: $shortname)
    }
  }
`;

export const OWNER_HEADER_QUERY = gql`
  query OwnerHeaderQuery {
    viewer {
      user {
        id
        givenName
        familyName
        externalImageUrl
        orgs {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    }
  }
`;
